import React, { useState } from "react";
import logo from "../../../images/logo/white-ontrack-logo.jpeg";
import { GoPerson } from "react-icons/go";
import { RiLockPasswordLine } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import { api1 } from "../../../utils/axiosInstance";
import { EyeIcon, EyeOffIcon } from "@heroicons/react/solid"; // Ensure you have the correct icon import
import { toast } from "react-toastify";

const NewPasswordForm = () => {
  const navigate = useNavigate();
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false); // State to toggle visibility
  const [showConfirmPassword, setShowConfirmPassword] = useState(false); // Separate state for confirm password visibility

  const handleNewPassword = async (e) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      toast.error("Passwords do not match!");
      return;
    }

    const email = localStorage.getItem("userEmail"); // Get email from localStorage
    if (!email) {
      toast.error("Email is not found. Please try again.");
      return;
    }

    try {
      const response = await api1.post("/api/auth/resetpassword", {
        email,
        newPassword,
        confirmPassword,
      });

      if (response.data) {
        navigate("/auth/newpasswordsuccess"); // Redirect after successful reset
      }
    } catch (error) {
      console.error("API Error:", error);
      toast.error("An error occurred, please try again later.");
    }
  };

  return (
    <div className="w-full flex flex-col items-center justify-center p-8 bg-white">
      <img
        src={logo}
        alt="LogIn Info"
        className="absolute top-4 left-4 w-28 h-auto hover:cursor-pointer"
        onClick={() => navigate("/")}
      />
      <h1 className="text-3xl font-bold text-purple-800 mb-2">New Password</h1>
      <p className="text-gray-500 mb-6">
        Welcome to OnTrack Careers! Let's get started by creating your new
        password.
      </p>
      <form className="w-full max-w-md">
        {/* New Password Field */}
        <div className="mb-4">
          <div className="flex items-center border border-gray-300 rounded px-3 py-2">
            <RiLockPasswordLine className="mr-2" />
            <input
              type={showPassword ? "text" : "password"}
              placeholder="New password here"
              className="w-full outline-none text-gray-700"
              onChange={(e) => setNewPassword(e.target.value)}
              value={newPassword}
            />
            <div
              className="cursor-pointer ml-2"
              onClick={() => setShowPassword(!showPassword)} // Toggle password visibility
            >
              {showPassword ? (
                <EyeOffIcon className="w-5 h-5 text-gray-500" />
              ) : (
                <EyeIcon className="w-5 h-5 text-gray-500" />
              )}
            </div>
          </div>
        </div>

        {/* Confirm Password Field */}
        <div className="mb-4">
          <div className="flex items-center border border-gray-300 rounded px-3 py-2">
            <GoPerson className="mr-2" />
            <input
              type={showConfirmPassword ? "text" : "password"}
              placeholder="Confirm Password"
              className="w-full outline-none text-gray-700"
              onChange={(e) => setConfirmPassword(e.target.value)}
              value={confirmPassword}
            />
            <div
              className="cursor-pointer ml-2"
              onClick={() => setShowConfirmPassword(!showConfirmPassword)} // Toggle password visibility
            >
              {showConfirmPassword ? (
                <EyeOffIcon className="w-5 h-5 text-gray-500" />
              ) : (
                <EyeIcon className="w-5 h-5 text-gray-500" />
              )}
            </div>
          </div>
        </div>

        {/* Submit Button */}
        <button
          onClick={handleNewPassword}
          className="w-full py-3 text-white bg-gradient-to-r from-pink-500 to-blue-700 rounded-lg shadow-md hover:opacity-90 transition-all"
        >
          Change Password
        </button>
      </form>
    </div>
  );
};

export default NewPasswordForm;
